import axios from "axios";
import { baseUrl } from "../util";
import Swal from "sweetalert2";

/**
 * Get Mass Balance totals for a product
 * @param {Object} params
 * @param {string} params.productId - Product ID
 * @param {Function} params.setObjects - Callback to set the totals data
 */
export const getMassBalance47Totals = ({ productId, setObjects = () => {} }) => {
  const config = {
    method: "get",
    url: `${baseUrl}/api/business/product/${productId}/mass-balance-47-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (response?.data?.data) {
        setObjects(response.data.data);
      } else {
        setObjects(null);
      }
    })
    .catch(function (error) {
      console.error("Error fetching mass balance totals:", error);
      setObjects(null);
    });
};

/**
 * Get Mass Balance data (phases, inputs, outputs) for a product
 * @param {Object} params
 * @param {string} params.productId - Product ID
 * @param {Function} params.setObjects - Callback to set the mass balance data
 */
export const getMassBalance47Data = ({ productId, setObjects = () => {} }) => {
  const config = {
    method: "get",
    url: `${baseUrl}/api/business/product/${productId}/mass-balance-47-data`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (response?.data?.data) {
        setObjects(response.data.data);
      } else {
        setObjects(null);
      }
    })
    .catch(function (error) {
      console.error("Error fetching mass balance data:", error);
      setObjects(null);
    });
};

/**
 * Get Mass Balance Sankey data (nodes and links) for visualization
 * @param {Object} params
 * @param {string} params.productId - Product ID
 * @param {Function} params.setObjects - Callback to set the sankey data
 */
export const getMassBalance47Sankey = ({ productId, setObjects = () => {} }) => {
  const config = {
    method: "get",
    url: `${baseUrl}/api/business/product/${productId}/mass-balance-47-sankey`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (response?.data?.data) {
        setObjects(response.data.data);
      } else {
        setObjects(null);
      }
    })
    .catch(function (error) {
      console.error("Error fetching mass balance sankey data:", error);
      setObjects(null);
    });
};

